import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useSidebar } from '../../contexts/SidebarContext';
import LanguageSelector from '../LanguageSelector';
import { showError } from '../../utils/handleApiError';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const { toggle } = useSidebar();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      showError('Nem sikerült kijelentkezni');
    }
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            {/* Hamburger menu button */}
            <button
              onClick={toggle}
              className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500 mr-4"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <h1 className="text-xl md:text-2xl font-semibold text-gray-900">
              <span className="hidden sm:inline">{t('dashboard', 'menu')} - </span>
              <span className="sm:hidden">Livestock</span>
              <span className="hidden sm:inline">Állattenyésztési Rendszer</span>
            </h1>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* Language Selector - hide text on mobile */}
            <div className="hidden sm:block">
              <LanguageSelector />
            </div>
            <div className="sm:hidden">
              <LanguageSelector showText={false} />
            </div>
            
            {/* Notification bell - hidden on mobile */}
            <button className="hidden sm:block p-2 text-gray-400 hover:text-gray-500 relative">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 17h5l-5 5v-5zM11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                />
              </svg>
              <span className="absolute top-1 right-1 h-2 w-2 bg-red-400 rounded-full"></span>
            </button>

            {/* User menu */}
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="hidden lg:block">
                <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                <p className="text-xs text-gray-500 capitalize">
                  {user?.role.replace('_', ' ')}
                </p>
              </div>
              
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-green-500 rounded-full flex items-center justify-center">
                <span className="text-white font-medium text-xs sm:text-sm">
                  {user?.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>

              <button
                onClick={handleLogout}
                className="p-1 sm:p-2 text-gray-400 hover:text-gray-500"
                title={t('logout', 'auth')}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;